// import { getPreferredCameraId } from 'utils/camera';

// GeniusScan Configuration
export const createGeniusScanConfiguration = ({
  palette,
  selectedCameraId
}) => ({
  source: 'camera',
  multiPage: false,
  requiredReadabilityLevel: 'medium',
  outputOriginalImage: false,
  defaultFilter: 'photo',
  foregroundColor: palette.background.paper,
  backgroundColor: palette.secondary.main,
  highlightColor: palette.primary.main,
  jpegQuality: 100,
  cameraId: selectedCameraId || undefined
});

export const runGeniusScan = async ({ config }) => {
  if (!window.GSSDK) {
    throw new Error('GSSDK not available');
  }

  const result = await window.GSSDK.scanWithConfiguration(config);

  if (!result || !result.scans || result.scans.length === 0) {
    return { cancelled: true };
  }

  const enhancedBlob = result.scans[0]?.enhancedImage?.data;

  if (!enhancedBlob) {
    throw new Error('No enhanced image found in the result');
  }

  const objectUrl = URL.createObjectURL(enhancedBlob);

  return { cancelled: false, enhancedBlob, objectUrl };
};

// Dynamsoft Configuration
export const createDynamsoftScanConfiguration = ({ license }) => ({
  license: license,
  scannerViewConfig: {
    enableAutoCropMode: true,
    enableSmartCaptureMode: true,
    showSubfooter: false,
    showPoweredByDynamsoft: false
  }
});

export const initializeDynamsoftScanner = async ({ licenseKey }) => {
  // const preferredCameraId = await getPreferredCameraId();

  const config = createDynamsoftScanConfiguration({
    license: licenseKey
  });

  return new window.Dynamsoft.DocumentScanner(config);
};
